import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=1685fab7&scoped=true"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685fab7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1685fab7')) {
      api.createRecord('1685fab7', component.options)
    } else {
      api.reload('1685fab7', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=1685fab7&scoped=true", function () {
      api.rerender('1685fab7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/icon/icon.vue"
export default component.exports